var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVpbankSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3652 15.4263H34.7841C32.1262 15.4263 29.6052 16.5851 27.8693 18.6032L20.6304 27.0147V36.6249C22.9641 36.2964 24.1886 34.726 24.1886 34.726L39.8333 16.4876C40.2043 16.0797 39.9162 15.4299 39.3652 15.4299",
    fill: "#E10600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.634966 15.4263H5.21602C7.87389 15.4263 10.3949 16.5851 12.1308 18.6032L19.3697 27.0147V36.6249C17.036 36.2964 15.8115 34.726 15.8115 34.726L0.166777 16.4876C-0.204173 16.0797 0.0839434 15.4299 0.634966 15.4299",
    fill: "#E10600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2487 3.62485V12.9931C29.2487 14.3216 28.7733 15.6068 27.9053 16.6141L20.6304 25.0689V11.9606L28.1574 3.21691C28.5356 2.78008 29.2523 3.04723 29.2523 3.62485",
    fill: "#E10600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 3.62485V12.9931C10.7516 14.3216 11.227 15.6068 12.095 16.6141L19.3699 25.0689V11.9606L11.8429 3.21691C11.4647 2.78008 10.748 3.04723 10.748 3.62485",
    fill: "#E10600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpbankSquare);
export default __webpack_public_path__ + "static/media/vpbank-square.9a23bab480ac38078b2610aeb2e23c48.svg";
export { ForwardRef as ReactComponent };